import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormRequerimentosComponent } from './form-requerimentos/form-requerimentos.component';
import { RequerimentosRoutingModule } from './requerimentos-routing.module';
import {TableModule} from 'primeng/table';
import { ButtonModule } from 'primeng/button';





@NgModule({
  declarations: [
    FormRequerimentosComponent,
  ],
  imports: [
    CommonModule,
    RequerimentosRoutingModule,
    TableModule,
    ButtonModule
  ]
})
export class RequerimentosModule { }
